function ConversationMessageRead(): null {
    return null;
}

export default ConversationMessageRead;
